import { PopupDialogAction, PopupDialogActionOptions } from '../models/popup-dialog-object';

export class ReusableActionsUtil {

	public static generateActions(firstFailedPortfolio: any, errorReviewHoldingsLabel: string, errorNewAnalysisLabel: string): PopupDialogAction[] {
		return [
			PopupDialogAction.create({
				label: errorReviewHoldingsLabel,
				type: 'view_portfolio_editor',
				reload: false,
				portfolioId: firstFailedPortfolio.id
			} as PopupDialogActionOptions),
			PopupDialogAction.create({
				label: errorNewAnalysisLabel,
				type: 'view_new_analysis',
				reload: false,
				actionClass: 'btn-secondary'
			} as PopupDialogActionOptions)
		];
	}
}
